

export class ReminderStatusInput implements IReminderStatusInput {
    /** The auto-generated id of the reminder master */
    reminderId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IReminderStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderId = _data["reminderId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReminderStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderId"] = this.reminderId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IReminderStatusInput {
    /** The auto-generated id of the reminder master */
    reminderId: number;
    /** The updated status */
    status: number;
}

